<template>
  <div style="margin-top:70px;">

    <analytics-tab-navigation />
   
    <div class="mt-3"> 
      <analytics-root v-if="activeOption == 'analytics-root'" />
      <analytics-breakdown-day v-if="activeOption == 'analytics-breakdown-day'" />
      <analytics-grouped v-if="activeOption == 'analytics-grouped'" />
      <analytics-bus-companies-breakdown  v-if="activeOption == 'analytics-bus-companies-breakdown-day'" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AnalyticsTabNavigation from '../../components/Analytics/AnalyticsTabNavigation'
import AnalyticsRoot from '../../components/Analytics/AnalyticsRoot.vue'
import AnalyticsBreakdownDay from '../../components/Analytics/Breakdown/AnalyticsBreakdownDay.vue'
import AnalyticsGrouped from '../../components/Analytics/Grouped/AnalyticsGrouped.vue'
import AnalyticsBusCompaniesBreakdown from '../../components/Analytics/BusCompaniesBreakdown/AnalyticsBusCompaniesBreakdown.vue'

import { mapGetters } from "vuex";

export default {
  components: {
    AnalyticsTabNavigation,
    AnalyticsRoot,
    AnalyticsBreakdownDay,
    AnalyticsGrouped,
    AnalyticsBusCompaniesBreakdown
  },
  created() {
    this.$store.dispatch('layout/setActiveTabAndOption', {tab: 'Admin', option: 'analytics-root'})
  },
  computed: {
      ...mapGetters(["trekksoftClient", 'activeTab', 'activeOption'])
  },
  
};
</script>
